"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'login.form.title': 'Iniciar sesión',
    'login.form.hero.title': 'Bienvenido de vuelta',
    'login.form.hero.description': 'Por favor usa tus credenciales para iniciar sesión.',
    'login.form.hero.register_link_text': 'Si no eres miembro, por favor',
    'login.form.hero.register_link': 'regístrate aquí',
};
